import type { StreamStartStatus } from '@/features/live/types';

/**
 * Live confirmé côté présentateur/modérateur : on s'appuie strictement sur le statut back.
 * Les retries egress sont gérés côté back, donc READY/PARTIAL font foi et FAILED n'est jamais
 * contourné (un ancien filet quorum lisait le `ready` par flux, qui décrit la vitalité d'un flux
 * et non l'issue du lancement).
 */
export function isLiveConfirmed(status: StreamStartStatus): boolean {
  return status === 'READY' || status === 'PARTIAL';
}

/**
 * Overlay de lancement (PENDING/FAILED) : pertinent uniquement pour un vrai live avec egress.
 * Un evergreen joue un mp4 pré-baké, sans lancement de flux, donc le streamStartStatus (que le
 * back peut émettre par ailleurs) ne doit jamais y déclencher l'overlay.
 */
export function shouldShowLaunchOverlay(isEvergreen: boolean, status: StreamStartStatus): boolean {
  if (isEvergreen || isLiveConfirmed(status)) return false;
  return status === 'PENDING' || status === 'FAILED';
}

/**
 * Rechargement présentateur en cours de live : le back reste IN_PROGRESS mais le streamStartStatus
 * (client) repart de IDLE, ce qui fait perdre le mode live (timer + Clôturer). On ré-hydrate alors
 * depuis la vérité back. La condition `IDLE` est volontaire : pendant un lancement, streamStartStatus
 * vaut déjà PENDING, donc ce cas ne se déclenche jamais en plein démarrage (pas de régression 334).
 */
export function shouldRestoreLiveOnReload(
  sessionStatus: string | null | undefined,
  streamStartStatus: StreamStartStatus,
): boolean {
  return sessionStatus === 'IN_PROGRESS' && streamStartStatus === 'IDLE';
}
